import gql from 'graphql-tag';

const GET_RUNBOOKS = gql`
  query getRunbooks($input: ListInfoInput!) {
    getRunbooks(input: $input) {
      runbook {
        sopId
        name
        description
        displayIcon
        status
        layoutMeta
        createdBy {
          userId
          name
        }
        createdAt
        completedCount
        associatedCount
      }
      listInfo {
        page
        pageSize
        hasMore
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_RUNBOOKS_FOR_DROPDOWN = gql`
  query getRunbooks($input: ListInfoInput!) {
    getRunbooks(input: $input) {
      runbook {
        sopId
        name
      }
      listInfo {
        page
        pageSize
        hasMore
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_RUNBOOK = gql`
  query getRunbook($input: RunbookIdentifierInput!) {
    getRunbook(input: $input) {
      sopId
      name
      description
      displayIcon
      status
      layoutMeta
      # createdBy
      createdAt
      completedCount
      actions {
        flowAction {
          actionId
          name
          actionType
          actionProcessCategory
          actionValueType
          actionValueData
          groupActions {
            flowAction {
              actionId
              name
              actionType
              actionProcessCategory
              actionValueType
              actionValueData
            }
            actionOrder
          }
        }
        parentFlowAction {
          actionId
        }
        actionOrder
      }
    }
  }
`;

const DELETE_RUNBOOK = gql`
  mutation deleteRunbook($input: RunbookIdentifierInput!) {
    deleteRunbook(input: $input)
  }
`;

const CREATE_RUNBOOK = gql`
  mutation createRunbook($input: CreateRunbookInput!) {
    createRunbook(input: $input) {
      sopId
      name
      description
      displayIcon
      status
      layoutMeta
      actions {
        flowAction {
          actionId
          name
          actionType
          actionProcessCategory
          actionValueType
          actionValueData
          groupActions {
            flowAction {
              actionId
              name
              actionType
              actionProcessCategory
              actionValueType
              actionValueData
            }
            actionOrder
          }
        }
        parentFlowAction {
          actionId
        }
        actionOrder
      }
    }
  }
`;

const UPDATE_RUNBOOK = gql`
  mutation updateRunbook($input: UpdateRunbookInput!) {
    updateRunbook(input: $input) {
      sopId
      name
      description
      displayIcon
      status
      layoutMeta
      actions {
        flowAction {
          actionId
          name
          actionType
          actionProcessCategory
          actionValueType
          actionValueData
          groupActions {
            flowAction {
              actionId
              name
              actionType
              actionProcessCategory
              actionValueType
              actionValueData
            }
            actionOrder
          }
        }
        parentFlowAction {
          actionId
        }
        actionOrder
      }
    }
  }
`;

const CLONE_RUNBOOK = gql`
  mutation cloneRunbook($input: CloneRunbookInput!) {
    cloneRunbook(input: $input) {
      sopId
      name
      description
      displayIcon
      status
      layoutMeta
    }
  }
`;

const GET_RUNBOOK_ACTION_AUDIT = gql`
  query getRunbookActionAudit($input: GetRunbookActionAuditInput!) {
    getRunbookActionAudit(input: $input) {
      runbook {
        sopId
        name
        description
        displayIcon
        # actions
        # status
        # layoutMeta
        # createdBy {
        #   userId
        #   name
        # }
        # createdAt
        # completedCount
        # associatedCount: Int #Dynamically counted, use only in getRunbooks API
        actions {
          flowAction {
            actionId
            name
            actionType
            actionProcessCategory
            actionValueType
            actionValueData
            groupActions {
              flowAction {
                actionId
                name
                actionType
                actionProcessCategory
                actionValueType
                actionValueData
              }
              actionOrder
            }
          }
          parentFlowAction {
            actionId
          }
          actionOrder
        }
      }

      actionAudit {
        action {
          actionId
          # name
          # actionType
          # actionProcessCategory
          # actionValueType
          # actionValueData

          # groupActions {
          #   flowAction {
          #     actionId
          #     name
          #     actionType
          #     actionProcessCategory
          #     actionValueType
          #     actionValueData
          #   }
          #   actionOrder
          # }
        }
        status
        lastUpdatedTime
        auditValueType
        auditValueData
      }
    }
  }
`;

const GET_RUNBOOKS_APPROVERS_META = gql`
  query getRunbookApproverMetaInfo {
    getRunbookApproverMetaInfo
  }
`;

const GET_RUNBOOKS_TICKET_PROPERTY_META = gql`
  query getTicketMetaForRunbookAction {
    getTicketMetaForRunbookAction
  }
`;

const EXECUTE_ENTITY_FLOW_ACTION = gql`
  mutation executeEntityFlowAction($input: EntityFlowActionIdentifierInput!) {
    executeEntityFlowAction(input: $input) {
      action {
        actionId
        name
        # actionType
        # actionProcessCategory
        # actionValueType
        # actionValueData
      }
      status
      lastUpdatedTime
      auditValueType
      auditValueData
    }
  }
`;
const GET_TASK_CONTENT_FROM_TEMPLATE = gql`
  query getTaskContentFromTemplate($input: [TaskTemplateIdentifierInput]!) {
    getTaskContentFromTemplate(input: $input) {
      title
      description
      estimatedTime
      scheduledStartDate
      dueDate
      techGroup {
        groupId
        name
      }
      technician {
        userId
        name
        firstName
        lastName
      }
      taskOrder
    }
  }
`;

const GET_RUNBOOK_APPROVERS = gql`
  query getRunbookApprovers($input: GetRunbookApproversInput!) {
    getRunbookApprovers(input: $input) {
      users {
        userId
        name
        email
      }
      roleType
      # listInfo {
      #   page
      #   pageSize
      #   sort {
      #     attribute
      #     order
      #   }
      # }
    }
  }
`;

const UPDATE_ENTITY_FLOW_ACTION_STATUS = gql`
  mutation updateEntityFlowActionStatus(
    $input: UpdateEntityFlowActionStatusInput!
  ) {
    updateEntityFlowActionStatus(input: $input) {
      action {
        actionId
        name
        actionType
        actionProcessCategory
        actionValueType
        actionValueData
      }
      status
      lastUpdatedTime
      auditValueType
      auditValueData
    }
  }
`;

const GET_RUNBOOK_ACTION_INFO = gql`
  query getRunbookActionInfo($input: GetRunbookActionInfoInput!) {
    getRunbookActionInfo(input: $input) {
      action {
        actionId
      }
      status
      lastUpdatedTime
      auditValueType
      auditValueData
    }
  }
`;

export {
  GET_RUNBOOK,
  GET_RUNBOOKS,
  CREATE_RUNBOOK,
  UPDATE_RUNBOOK,
  GET_RUNBOOKS_APPROVERS_META,
  DELETE_RUNBOOK,
  GET_RUNBOOK_ACTION_AUDIT,
  EXECUTE_ENTITY_FLOW_ACTION,
  GET_TASK_CONTENT_FROM_TEMPLATE,
  GET_RUNBOOK_APPROVERS,
  GET_RUNBOOKS_TICKET_PROPERTY_META,
  UPDATE_ENTITY_FLOW_ACTION_STATUS,
  GET_RUNBOOKS_FOR_DROPDOWN,
  CLONE_RUNBOOK,
  GET_RUNBOOK_ACTION_INFO
};
